module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Thin.f1035be.otf";